module.exports = __webpack_public_path__ + "static/img/ty.745b7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/ty.png
// module id = PhBs
// module chunks = 26